<template>
  <svg
    width="20"
    height="19"
    viewBox="0 0 20 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.125 11.875V15.0417C17.125 15.4616 16.9582 15.8643 16.6613
      16.1613C16.3643 16.4582 15.9616 16.625 15.5417 16.625H4.45833C4.03841
      16.625 3.63568 16.4582 3.33875 16.1613C3.04181 15.8643 2.875 15.4616 2.875 15.0417V11.875"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.04102 7.9165L9.99935 11.8748L13.9577 7.9165"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 11.875V2.375"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>